import React, { useState } from 'react';
import { Search, X, Plus, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Dhandeshjama = () => {
    const navigate = useNavigate();
  const [date, setDate] = useState('01/04/2025');
  const [records, setRecords] = useState([]);
  
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalDate, setModalDate] = useState(() => {
    const today = new Date();
    return `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  });
  const [voucherNo, setVoucherNo] = useState('');
  const [gateNo, setGateNo] = useState('');
  const [personName, setPersonName] = useState('');
  const [khatavani, setKhatavani] = useState('');
  const [dhandesh, setDhandesh] = useState('');
  const [notes, setNotes] = useState('');
  const [accountRows, setAccountRows] = useState([
    { id: 1, account: '', creditAmount: '', debitAmount: '', description: '' }
  ]);
  
  // Dhandesh popup state
  const [showDhandeshPopup, setShowDhandeshPopup] = useState(false);
  const [dhandeshNo, setDhandeshNo] = useState('');
  const [dhandeshDate, setDhandeshDate] = useState(() => {
    const today = new Date();
    return `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  });
  const [bankName, setBankName] = useState('');
  const [dhandeshNotes, setDhandeshNotes] = useState('');

  const handleSearch = () => {
    console.log('Searching for date:', date);
  };

  const handleOpenModal = () => {
    setShowModal(true);
    // Reset form
    const today = new Date();
    setModalDate(`${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`);
    setVoucherNo('');
    setGateNo('');
    setPersonName('');
    setNotes('');
    setAccountRows([{ id: 1, account: '', creditAmount: '', debitAmount: '', description: '' }]);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAddRow = () => {
    const newId = accountRows.length > 0 ? Math.max(...accountRows.map(r => r.id)) + 1 : 1;
    setAccountRows([...accountRows, { id: newId, account: '', creditAmount: '', debitAmount: '', description: '' }]);
  };

  const handleDeleteRow = (id) => {
    if (accountRows.length > 1) {
      setAccountRows(accountRows.filter(row => row.id !== id));
    }
  };

  const handleRowChange = (id, field, value) => {
    setAccountRows(accountRows.map(row => 
      row.id === id ? { ...row, [field]: value } : row
    ));
  };

  const handleOpenDhandeshPopup = () => {
    setShowDhandeshPopup(true);
  };

  const handleCloseDhandeshPopup = () => {
    setShowDhandeshPopup(false);
  };

  const handleSaveDhandesh = () => {
    // Save dhandesh details to the main dhandesh field
    const dhandeshDetails = `${dhandeshNo} - ${bankName}`;
    setDhandesh(dhandeshDetails);
    console.log('Dhandesh saved:', {
      dhandeshNo,
      dhandeshDate,
      bankName,
      dhandeshNotes
    });
    handleCloseDhandeshPopup();
  };

  const handleSave = () => {
    // Validate form
    if (!personName.trim()) {
      alert('कृपया व्यक्तीचे नाव प्रविष्ट करा');
      return;
    }

    // Calculate total amounts
    const totalCredit = accountRows.reduce((sum, row) => sum + (parseFloat(row.creditAmount) || 0), 0);
    const totalDebit = accountRows.reduce((sum, row) => sum + (parseFloat(row.debitAmount) || 0), 0);

    const newRecord = {
      date: modalDate,
      serialNo: voucherNo,
      name: personName,
      amount: totalCredit,
      cess: notes,
      proof: ''
    };

    setRecords([...records, newRecord]);
    console.log('Saved record:', newRecord);
    console.log('Account rows:', accountRows);
    handleCloseModal();
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white px-6 py-3 rounded-t-lg flex justify-between items-center">
        <h1 className="text-xl font-semibold">धनादेश जमा</h1>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="bg-white/20 hover:bg-white/30 text-white px-4 py-1 rounded text-sm font-medium flex items-center gap-2 backdrop-blur-sm transition"
          >
            <ArrowLeft size={16} />
            मागे
          </button>
          <button
            onClick={handleOpenModal}
            className="bg-green-500 hover:bg-green-600 px-4 py-1 rounded text-sm font-medium"
          >
            नोंद+
          </button>
        </div>
      </div>

      {/* Search Section */}
      <div className="bg-white px-6 py-4 border-b border-gray-200">
        <div className="flex items-center gap-4">
          <label className="text-gray-700 font-medium">दिनांक</label>
          <input
            type="text"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="border border-gray-300 rounded px-3 py-1 w-32"
            placeholder="01/04/2025"
          />
          {/* <input
            type="date"
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              const formattedDate = `${String(selectedDate.getDate()).padStart(2, '0')}/${String(selectedDate.getMonth() + 1).padStart(2, '0')}/${selectedDate.getFullYear()}`;
              setDate(formattedDate);
            }}
            className="border border-gray-300 rounded px-2 py-1"
          /> */}
          <button
            onClick={handleSearch}
            className="bg-primary hover:bg-primary-dark text-white px-6 py-1 rounded font-medium"
          >
            शोधा
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-b-lg overflow-hidden shadow">
        <table className="w-full">
          <thead>
            <tr className="bg-primary text-white">
              <th className="px-4 py-3 text-left border-r border-primary-dark">दिनांक</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">वाउचर क्रमांक</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">व्यक्तीचे नाव</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">रक्कम</th>
              <th className="px-4 py-3 text-left border-r border-primary-dark">शेरा</th>
              <th className="px-4 py-3 text-left">पर्याय</th>
            </tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-6 text-gray-500 text-left">
                  No records found
                </td>
              </tr>
            ) : (
              records.map((record, index) => (
                <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-4 py-3">{record.date}</td>
                  <td className="px-4 py-3">{record.serialNo}</td>
                  <td className="px-4 py-3">{record.name}</td>
                  <td className="px-4 py-3">{record.amount}</td>
                  <td className="px-4 py-3">{record.cess}</td>
                  <td className="px-4 py-3">{record.proof}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="bg-blue-600 px-4 py-3 flex items-center justify-center gap-2">
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            «
          </button>
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            ‹
          </button>
          <span className="bg-white text-gray-700 px-3 py-1 rounded font-medium">1</span>
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            ›
          </button>
          <button className="bg-blue-500 hover:bg-blue-400 text-white px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            »
          </button>
          <select className="bg-white border border-gray-300 rounded px-2 py-1 ml-2">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-5xl max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-primary to-primary-dark text-white px-6 py-3 rounded-t-lg flex justify-between items-center sticky top-0">
              <h2 className="text-xl font-semibold">धनादेश जमा</h2>
              <button onClick={handleCloseModal} className="text-white hover:text-gray-200">
                <X size={24} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              {/* Date and Search Fields */}
              <div className="flex items-center gap-4 mb-4 flex-wrap">
                <div className="flex items-center gap-2">
                  <label className="text-gray-700 font-medium">दिनांक</label>
                  <input
                    type="text"
                    value={modalDate}
                    onChange={(e) => setModalDate(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 w-32"
                  />
                </div>
                <button className="bg-green-500 hover:bg-green-600 text-white px-4 py-1 rounded font-medium">
                 जमा व्हॉउचर
                </button>
                <div className="flex items-center gap-2 ml-auto">
                  <label className="text-gray-700 font-medium">चलन क्र.</label>
                  <input
                    type="text"
                    value={voucherNo}
                    onChange={(e) => setVoucherNo(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 w-24"
                  />
                </div>
               
              </div>

              {/* Person Name */}
              <div className="flex items-center gap-4 mb-4">
                <label className="text-gray-700 font-medium">व्यवहाराचे नांव :</label>
                <div className="flex-1 flex items-center gap-2">
                  <input
                    type="text"
                    value={personName}
                    onChange={(e) => setPersonName(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 flex-1"
                    placeholder="व्यवहाराचे नांव"
                  />
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded">
                    <Search size={20} />
                  </button>
                </div>
              </div>

              {/* Account Search Field */}
              <div className="flex items-center gap-4 mb-4">
                <label className="text-gray-700 font-medium">खातावणी</label>
                <div className="flex-1 flex items-center gap-2">
                  <input
                    type="text"
                    value={khatavani}
                    onChange={(e) => setKhatavani(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 flex-1"
                    placeholder="खातावणी"
                  />
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded">
                    +
                  </button>
                </div>
              </div>

              {/* Dhandesh Field */}
              <div className="flex items-center gap-4 mb-4">
                <label className="text-gray-700 font-medium">धनादेश</label>
                <div className="flex-1 flex items-center gap-2">
                  <input
                    type="text"
                    value={dhandesh}
                    onChange={(e) => setDhandesh(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-1 flex-1"
                    placeholder="धनादेश"
                  />
                  <button 
                    onClick={handleOpenDhandeshPopup}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded"
                  >
                    +
                  </button>
                </div>
              </div>

              {/* Account Selection Table */}
              <div className="overflow-x-auto mb-4">
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-blue-600 text-white">
                      <th className="px-2 py-2 text-left border-r border-blue-500 w-12">#</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500">खातावणी विविडस</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500 w-32">जमा रक्कम</th>
                      <th className="px-4 py-2 text-left border-r border-blue-500 w-32">माहीणी रक्कम</th>
                      <th className="px-4 py-2 text-left w-32">शिल्लक</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountRows.map((row, index) => (
                      <tr key={row.id} className="border-b border-gray-200">
                        <td className="px-2 py-2 border-r border-gray-200">
                          <button
                            onClick={() => handleDeleteRow(row.id)}
                            className="bg-red-500 hover:bg-red-600 text-white rounded w-6 h-6 flex items-center justify-center"
                            disabled={accountRows.length === 1}
                          >
                            <X size={14} />
                          </button>
                        </td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <div className="flex items-center gap-1">
                            <input
                              type="text"
                              value={row.account}
                              onChange={(e) => handleRowChange(row.id, 'account', e.target.value)}
                              className="w-full border border-gray-300 rounded px-2 py-1"
                              placeholder="खाते निवडा"
                            />
                            <button className="bg-blue-600 hover:bg-blue-700 text-white rounded px-2 py-1 text-sm">
                              +
                            </button>
                          </div>
                        </td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <input
                            type="number"
                            value={row.creditAmount}
                            onChange={(e) => handleRowChange(row.id, 'creditAmount', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1 text-right"
                            placeholder="0"
                          />
                        </td>
                        <td className="px-2 py-2 border-r border-gray-200">
                          <input
                            type="number"
                            value={row.debitAmount}
                            onChange={(e) => handleRowChange(row.id, 'debitAmount', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1 text-right"
                            placeholder="0"
                          />
                        </td>
                        <td className="px-2 py-2">
                          <input
                            type="text"
                            value={row.description}
                            onChange={(e) => handleRowChange(row.id, 'description', e.target.value)}
                            className="w-full border border-gray-300 rounded px-2 py-1 text-right"
                            placeholder="0"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Notes */}
              <div className="mb-6">
                <label className="text-gray-700 font-medium block mb-2">शेरा</label>
                <textarea
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  rows="3"
                  placeholder="शेरा"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-center gap-4">
                <button
                  onClick={handleSave}
                  className="bg-green-500 hover:bg-green-600 text-white px-8 py-2 rounded font-medium"
                >
                  साठावणी
                </button>
                <button
                  onClick={handleCloseModal}
                  className="bg-red-500 hover:bg-red-600 text-white px-8 py-2 rounded font-medium"
                >
                  रक्कर किरेणे
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Dhandesh Details Popup */}
      {showDhandeshPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-lg w-full max-w-2xl">
            {/* Popup Header */}
            <div className="bg-blue-700 text-white px-6 py-3 rounded-t-lg flex justify-between items-center">
              <h3 className="text-lg font-semibold">धनादेश सविस्तर माहिती</h3>
              <button onClick={handleCloseDhandeshPopup} className="text-white hover:text-gray-200">
                <X size={20} />
              </button>
            </div>

            {/* Popup Body */}
            <div className="p-6">
              {/* Dhandesh Number */}
              <div className="mb-4">
                <label className="text-gray-700 font-medium block mb-2">धनादेश नं.:</label>
                <input
                  type="text"
                  value={dhandeshNo}
                  onChange={(e) => setDhandeshNo(e.target.value)}
                  className="w-full border border-blue-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
                  placeholder="धनादेश नं. भरा."
                />
              </div>

              {/* Date */}
              <div className="mb-4">
                <label className="text-gray-700 font-medium block mb-2">दिनांक:</label>
                <div className="relative">
                  <input
                    type="text"
                    value={dhandeshDate}
                    onChange={(e) => setDhandeshDate(e.target.value)}
                    className="w-full border border-blue-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
                    placeholder="01/04/2025"
                  />
                  <button className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Bank Name */}
              <div className="mb-4">
                <label className="text-gray-700 font-medium block mb-2">बॅकेचे नाव:</label>
                <input
                  type="text"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                  className="w-full border border-blue-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
                  placeholder="बॅकेचे नाव भरा."
                />
              </div>

              {/* Notes */}
              <div className="mb-6">
                <label className="text-gray-700 font-medium block mb-2">शेरा</label>
                <textarea
                  value={dhandeshNotes}
                  onChange={(e) => setDhandeshNotes(e.target.value)}
                  className="w-full border border-blue-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
                  rows="3"
                  placeholder="शेरा भरा."
                />
              </div>

              {/* Save Button */}
              <div className="flex justify-center">
                <button
                  onClick={handleSaveDhandesh}
                  className="bg-green-500 hover:bg-green-600 text-white px-12 py-2 rounded font-medium"
                >
                  ठीक
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dhandeshjama;
